import {Injectable, inject} from '@angular/core';
import {TokenStorageService} from '@services/local-storage/token-storage/token-storage.service';
import {ApiService} from '@services/api/api.service';
import {UserStorageService} from '@services/local-storage/user-storage/user-storage.service';
import {Login} from '@interfaces/login';
import {Otp} from '@interfaces/otp';
import {Observable} from 'rxjs';
import {ApiResponse} from '@interfaces/response';
import {User} from '@interfaces/user';
import {ResetPassword} from '@interfaces/reset_password';
import {ResetPasswordConfirm} from '@interfaces/reset_password_confirm';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private api_service = inject(ApiService);
  private token_storage_service = inject(TokenStorageService);
  private user_storage_service = inject(UserStorageService);

  private login_url: string = '/auth/login';
  private logout_url: string = '/auth/logout';
  private verify_otp_url: string = '/auth/verify-otp';
  private resend_otp_url: string = '/auth/resend-otp/';
  private loggedin_url: string = '/users/me';
  private request_reset_password_url: string = '/auth/password/reset/';
  private reset_password_url: string = '/auth/password/reset/confirm/${uidb64}/${token}/';

  constructor() {
  }

  public login(email: string, password: string): Observable<ApiResponse<Login>> {
    const body = {email, password};
    return this.api_service.post<ApiResponse<Login>>(this.login_url, body);
  }

  public verify_otp(email: string, otp_code: string): Observable<ApiResponse<Otp>> {
    const body = {email, otp_code};
    return this.api_service.post<ApiResponse<Otp>>(this.verify_otp_url, body);
  }

  public resend_otp(email: string): Observable<ApiResponse<Login>> {
    const body = {email};
    return this.api_service.post<ApiResponse<Login>>(this.resend_otp_url, body);
  }

  public get_user_data(): Observable<ApiResponse<User>> {
    return this.api_service.get<ApiResponse<User>>(this.loggedin_url);
  }

  public request_reset_password(email: string): Observable<ApiResponse<ResetPassword>> {
    const body = { email};
    return this.api_service.post<ApiResponse<ResetPassword>>(this.request_reset_password_url, body);
  }

  public reset_password(new_password1: string, new_password2: string, uidb64: string, token: string): Observable<ApiResponse<ResetPasswordConfirm>> {
    const body = { new_password1, new_password2, uidb64, token };
    const url = this.reset_password_url
      .replace('${uidb64}', uidb64)
      .replace('${token}', token);
    return this.api_service.post<ApiResponse<ResetPasswordConfirm>>(url, body);
  }


  async isAuthenticated(): Promise<boolean> {
    const user = await this.user_storage_service.getUserStorage();
    const token = await this.token_storage_service.getTokenStorage();
    return token != null;
  }
}

